/**
 * Frequency & Stone PDP gallery.
 * Mirrors the frozen prototype: one selected main image, previous/next controls,
 * keyboard navigation, and a four-column thumbnail chooser on desktop. Mobile
 * adds a vertical rail with cyclic navigation. Kept independent of Horizon's
 * media-gallery so the custom FS PDP section has one scoped contract.
 */
(() => {
  function mount(gallery) {
    if (gallery.dataset.fsGalleryMounted === 'true') return;
    const slides = [...gallery.querySelectorAll('[data-fs-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-fs-gallery-thumbnail]')];
    if (!slides.length || !thumbnails.length) return;

    const previous = gallery.querySelector('[data-fs-gallery-previous]');
    const next = gallery.querySelector('[data-fs-gallery-next]');
    const thumbnailNext = gallery.querySelector('[data-fs-gallery-thumbnails-next]');
    const mobileQuery = window.matchMedia?.('(max-width: 980px)');
    let currentIndex = 0;

    function isMobile() {
      return Boolean(mobileQuery?.matches);
    }

    function normalizedIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function showImage(index) {
      currentIndex = normalizedIndex(index);
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== currentIndex;
      });
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const selected = thumbnailIndex === currentIndex;
        thumbnail.classList.toggle('is-current', selected);
        thumbnail.toggleAttribute('aria-current', selected);
      });
      if (previous) previous.disabled = currentIndex === 0;
      if (next) next.disabled = currentIndex === slides.length - 1;
      // Both desktop and mobile arrows are cyclic; keep the controls active at
      // the visual ends so the next click wraps to the opposite image.
      if (previous) previous.disabled = false;
      if (next) next.disabled = false;
      if (isMobile()) {
        thumbnails[currentIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => showImage(index));
    });
    previous?.addEventListener('click', () => showImage(currentIndex - 1));
    next?.addEventListener('click', () => showImage(currentIndex + 1));
    thumbnailNext?.addEventListener('click', () => showImage(currentIndex + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1);
      }
    });

    gallery.dataset.fsGalleryMounted = 'true';
    showImage(0);
  }

  function mountAll(root = document) {
    root.querySelectorAll('[data-fs-product-gallery]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  } else {
    mountAll();
  }
})();
